import styled from '@emotion/styled';

import { WHEEL_PADDING_ROWS, WHEEL_ROW_HEIGHT, WHEEL_VIEWPORT_HEIGHT } from './constants';

export const StyledWheelGroup = styled('div')({
  position: 'relative',
  display: 'flex',
  gap: 8,
  padding: 12,
  height: WHEEL_VIEWPORT_HEIGHT,
});

export const StyledWheelActiveRow = styled('div')(({ theme }) => ({
  position: 'absolute',
  zIndex: -1,
  left: 0,
  right: 0,
  top: WHEEL_PADDING_ROWS * WHEEL_ROW_HEIGHT,
  height: WHEEL_ROW_HEIGHT,
  borderRadius: 9999,
  backgroundColor: theme.colors.background.overlay,
  pointerEvents: 'none',
}));
